import { Helper } from '../../../../../../classes/helper'
import { useSidewall } from '../../../../../../hooks/state/useSidewall'
import { useMeasures } from '../../../../../../hooks/state/useMeasures'
import { Mesh, Shape } from 'three'
import { GlassOrPolyMaterial } from './GlassOrPolyMaterial'
import { useState } from 'react'

interface Props {
  height: number
  position: any
  windowsSideWidth: number
  cut: boolean
  opacity?: number | null
  roughness?: number | null
  isGlass?: boolean | null
  isOpal?: boolean | null
}

export const WallSideGlass = ({
  height,
  cut,
  position,
  windowsSideWidth,
  opacity = null,
  roughness = null,
  isGlass = null,
  isOpal = null,
}: Props) => {
  const { userAngle } = useMeasures()
  const { sidwallTyp, wallGlasColor } = useSidewall()
  const [ref, setRef] = useState<Mesh>()
  const slantedHeight1 = !cut
    ? Math.tan((userAngle * Math.PI) / 180) * windowsSideWidth
    : 0

  const windowShape = new Shape()
  windowShape
    .moveTo(-windowsSideWidth / 2, 0)
    .lineTo(-windowsSideWidth / 2, height)
    .lineTo(windowsSideWidth / 2, height - slantedHeight1)
    .lineTo(windowsSideWidth / 2, 0)

  const extrudeSettings = {
    depth: sidwallTyp.glas,
    bevelEnabled: false,
    bevelSegments: 20,
    steps: 2,
    bevelSize: 1,
    bevelThickness: 1,
  }

  return (
    <mesh
      // @ts-ignore
      ref={setRef}
      castShadow={true}
      position={position}
      rotation={[
        Helper.convertAngleToRadiant(0),
        Helper.convertAngleToRadiant(-90),
        Helper.convertAngleToRadiant(0),
      ]}
    >
      <extrudeGeometry
        attach="geometry"
        args={[windowShape, { ...extrudeSettings }]}
      />

      <GlassOrPolyMaterial
        parent={ref}
        isGlass={isGlass}
        isOpal={isOpal}
        opacity={opacity}
        roughness={roughness}
        color={wallGlasColor}
      />
    </mesh>
  )
}
